import React from 'react';
import TotalDeviceView from './TotalDeviceView';
import { UseTotalDeviceProps } from './type';
import { useTotalDevice } from './useTotalDevice';

function TotalDevice() {
  const hook: UseTotalDeviceProps = useTotalDevice();

  return <TotalDeviceView hook={hook} />;
}
export default React.memo(TotalDevice);
